import { jsx } from 'react/jsx-runtime';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { PrimitiveButton } from '../../../button/primitive-button/PrimitiveButton.mjs';
import { useChipContext } from '../../context.mjs';
import { chipContent, chipContentHorizontalGap } from './content.vanilla.mjs';

const ChipContent = forwardRef(
  ({ className: classNameFromProps, space, style: styleFromProps, ...props }, forwardedRef) => {
    const { size, state } = useChipContext("Chip.Content");
    const className = classNames(chipContent({ size }), classNameFromProps);
    const styles = Object.assign(
      {},
      assignInlineVars({
        [chipContentHorizontalGap]: space !== void 0 ? `${space}px` : null
      }),
      styleFromProps
    );
    return /* @__PURE__ */ jsx(
      PrimitiveButton,
      {
        "data-scope": "chip",
        "data-part": "content",
        "data-chip-state": state,
        className,
        style: styles,
        ref: forwardedRef,
        ...props
      }
    );
  }
);
ChipContent.displayName = "Chip.Content";

export { ChipContent };
//# sourceMappingURL=Content.mjs.map
